module.exports = __webpack_public_path__ + "static/media/logo.5c6be4e2.svg";